'use strict';

/**
 * @param {import('../types').Options} config
 */
module.exports = function (config) {
  return {
    get: require('./get')(config),
    stat: require('./stat')(config),
    put: require('./put')(config),
    rm: require('./rm')(config)
  };
};